<!-- 
    模板页
    lovi 2019-5-28
-->
<template>
  <div>
    <div class="w-1200 template">
      <left-nav :navList="navList"></left-nav>
      <div class="right-sidebar">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from "@/components/common/leftNav";
export default {
  name: "transfer",
  components: {
    LeftNav
  },
  data() {
    return {
      navList: [
        {
          path: "/transfer/batch",
          icon: "icon-batch",
          name: this.$t("transfer.batchTransfer")
        },
        {
          path: "/transfer/record",
          icon: "icon-record-more",
          name: this.$t("transfer.batchTransferRecord")
        }
      ]
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.template {
  display: flex;
  justify-content: space-between;
  .right-sidebar {
    flex: 1;
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    min-height: calc(100vh - 100px - 20px - 30px);
    overflow: hidden;
  }
}
</style>
